import script from "./Chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chat.vue?vue&type=script&setup=true&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=67e65de6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e65de6"]])

export default __exports__